import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { getUserManager } from "../../auth";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      padding: theme.spacing(2),
    },
    root: {
      maxWidth: 360,
      margin: `${theme.spacing(6)}px auto`,
      padding: theme.spacing(2),
    },
    title: {
      marginBottom: theme.spacing(2),
    },
    message: {
      marginTop: theme.spacing(1),
    },
    button: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(0.5),
      width: "100%",
    },
  });

interface SignedOutPageProps extends WithStyles<typeof styles> {
  onSignInError: (error: Error) => void;
}

interface SignedOutPageState {
  isSignInPending: boolean;
}

export const SignedOutPageComponent = class extends React.Component<SignedOutPageProps, SignedOutPageState> {
  constructor(props: SignedOutPageProps) {
    super(props);

    this.state = { isSignInPending: false };
  }

  public render() {
    const { classes } = this.props;
    const { isSignInPending } = this.state;

    return (
      <div className={classes.container}>
        <Paper className={classes.root} elevation={4}>
          <Typography className={classes.title} variant="h5" component="h3">
            Signed Out
          </Typography>
          <Typography className={classes.message} component="p">
            You are seeing this message because you explicitly signed out of your Account, or your device has been
            inactive for an extended period of time and your session expired.
          </Typography>
          <Typography className={classes.message} component="p">
            If you'd like to sign back in, select the button below.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            disabled={isSignInPending}
            onClick={this.handleSignInClick}
          >
            Sign in
          </Button>
        </Paper>
      </div>
    );
  }

  public handleSignInClick = async () => {
    const { onSignInError } = this.props;
    // Sign the user back in...
    window.sessionStorage.clear();
    this.setState({ isSignInPending: true });
    try {
      await getUserManager().signinRedirect({ data: { path: "/" } });
    } catch (error) {
      this.setState({ isSignInPending: false }, () => {
        onSignInError(error);
      });
    }
  };
};

export const SignedOutPage = withStyles(styles)(SignedOutPageComponent);
